Ext.define('SA.SidebarObserver', {
    constructor(activeState) {
        this.activeState = activeState;
        this.observable = new Ext.util.Observable();

        this.initEvents();
    },

    initEvents() {
        var events = ['use:location', 'use:attribute', 'use:business'],
            addListener = event => this.observable.mon(SA.Sidebar, event, (...args) => this.maybeFireEvent(event, ...args));

        events.forEach(event => addListener(event));
    },

    maybeFireEvent(event, ...args) {
        if (!this.activeState.isActive()) {
            return;
        }

        this.observable.fireEvent(event, ...args);
    },

    onUseAttribute(callback, scope) {
        this.observable.on('use:attribute', callback, scope);
    },

    onUseBusiness(callback, scope) {
        this.observable.on('use:business', callback, scope);
    },

    onUseLocation(callback, scope) {
        this.observable.on('use:location', callback, scope);
    }
});